import React from "react";
import { Route } from "react-router-dom";
import { warn } from "../utils/logger";

// State
import PropTypes from "prop-types";
import { connect } from "react-redux";

// UI Components
import { Spinner } from "react-bootstrap";

// Alternate Pages
import SignIn from "../pages/Auth/SignIn";
import Page401 from "../pages/Error/401";

interface State {
  user: {
    details: {
      permissions: string[];
    };
    loading: boolean;
    isAuthenticated: boolean;
  };
}

interface RouteOptions {
  user: object;
  loading: boolean;
  isAuthenticated: boolean;
  restrictedTo: string[];
  permissions: string[];
  [key: string]: any;
}

/**
 *
 * User must be logged in to view wrapped component
 * @param {boolean}   loading           Whether the user details are still loading
 * @param {boolean}   isAuthenticated   Whether the user is logged in or not
 * @param {string[]}  restrictedTo      Minimum user permission to view this route
 * @param {string[]}  permissions       Array of user permissions
 * @param {any}       rest              Pass remaining options through to child
 * @return Route
 * @constructor
 */
const RestrictedRoute = ({
  loading,
  permissions,
  restrictedTo,
  isAuthenticated,
  ...rest
}: RouteOptions) => {
  // If user does not have minimum permission level once loading finishes, display 401 page
  if (loading) {
    return <Spinner animation="border" role="status" />;
  }
  if (!isAuthenticated) {
    warn(`[i] Unauthenticated user visited url[${window.location.pathname}]`);
    return <SignIn />;
  }
  if (restrictedTo && !restrictedTo.find((permission) => permissions.includes(permission))) {
    warn(`[i] User does not have permissions for url[${window.location.pathname}]`, {
      restrictedTo,
      permissions,
    });
    return <Page401 {...rest} />;
  }

  // User is authenticated, show route
  // @ts-ignore
  return <Route {...rest} />;
};

RestrictedRoute.propTypes = {
  loading: PropTypes.bool.isRequired,
  permissions: PropTypes.array.isRequired,
  restrictedTo: PropTypes.array.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state: State) => ({
  loading: state.user.loading,
  user: state.user.details,
  permissions: state.user.details.permissions,
  isAuthenticated: state.user.isAuthenticated,
});

export default connect(mapStateToProps)(RestrictedRoute);
